import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import { useLocation } from 'react-router-dom';

function Header() {
    const location = useLocation();
    // イベントページ系のパス
    const isEventPage =
        location.pathname === '/event-room' ||
        location.pathname === '/event' ||
        location.pathname === '/mystery-event';
    const isMonouPage = location.pathname === '/monou-room';
    return (
        <AppBar
            position="fixed"
            elevation={0}
            sx={{
                background: isMonouPage
                    ? 'linear-gradient(90deg, #ffcc80 60%, #ffb74d 100%)' // オレンジ系（もん王用）
                    : isEventPage
                    ? 'linear-gradient(90deg, #fbc2eb 60%, #fcb69f 100%)' // ピンク系
                    : 'linear-gradient(90deg, #e3f2fd 60%, #90caf9 100%)', // 青空イメージ
                height: 56,
                borderBottom: isMonouPage ? '2px solid #e65100' : isEventPage ? '2px solid #d81b60' : '2px solid #1976d2',
                boxShadow: isMonouPage
                    ? '0 2px 8px rgba(255, 152, 0, 0.10)'
                    : isEventPage
                    ? '0 2px 8px rgba(240, 98, 146, 0.10)'
                    : '0 2px 8px rgba(33, 150, 243, 0.06)',
                justifyContent: 'center',
            }}
        >
            <Container maxWidth="md" sx={{ padding: 0 }}>
                <Toolbar
                    disableGutters
                    sx={{
                        minHeight: 56,
                        padding: '0 12px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'flex-start',
                    }}
                >
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            width: 48,
                            height: 48,
                            borderRadius: '50%',
                            background: isMonouPage
                                ? 'linear-gradient(135deg, rgba(230, 81, 0, 0.1), rgba(255, 183, 77, 0.2))'
                                : isEventPage
                                ? 'linear-gradient(135deg, rgba(216, 27, 96, 0.1), rgba(240, 98, 146, 0.2))'
                                : 'linear-gradient(135deg, rgba(25, 118, 210, 0.1), rgba(66, 165, 245, 0.2))',
                            boxShadow: isMonouPage
                                ? '0 4px 12px rgba(230, 81, 0, 0.2)'
                                : isEventPage
                                ? '0 4px 12px rgba(216, 27, 96, 0.2)'
                                : '0 4px 12px rgba(25, 118, 210, 0.2)',
                            transition: 'all 0.3s ease',
                            animation: 'logoFloat 4s ease-in-out infinite',
                            '@keyframes logoFloat': {
                                '0%': { transform: 'translateY(0px)' },
                                '25%': { transform: 'translateY(-2px)' },
                                '50%': { transform: 'translateY(0px)' },
                                '75%': { transform: 'translateY(-1px)' },
                                '100%': { transform: 'translateY(0px)' }
                            }
                        }}
                    >
                        <img 
                            src='/image/MAL.png' 
                            alt="ロゴ" 
                            style={{ 
                                width: 32, 
                                height: 32,
                                filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.1))',
                                transition: 'all 0.3s ease'
                            }} 
                        />
                    </Box>
                    <Typography
                        variant="h6"
                        noWrap
                        component="a"
                        href="/"
                        sx={{
                            mr: 1,
                            marginLeft: 3,
                            flexGrow: 1,
                            fontFamily: '"Orbitron", "Noto Sans JP", "Roboto", "Arial", sans-serif',
                            fontWeight: 900,
                            fontSize: '1.4rem',
                            letterSpacing: '0.1em',
                            background: isMonouPage
                                ? 'linear-gradient(45deg, #e65100, #ff9800, #e65100)'
                                : isEventPage
                                ? 'linear-gradient(45deg, #d81b60, #f06292, #d81b60)'
                                : 'linear-gradient(45deg, #1976d2, #42a5f5, #1976d2)',
                            backgroundSize: '200% 200%',
                            backgroundClip: 'text',
                            WebkitBackgroundClip: 'text',
                            WebkitTextFillColor: 'transparent',
                            textShadow: isMonouPage
                                ? '0 2px 4px rgba(230, 81, 0, 0.3)'
                                : isEventPage
                                ? '0 2px 4px rgba(216, 27, 96, 0.3)'
                                : '0 2px 4px rgba(25, 118, 210, 0.3)',
                            textDecoration: 'none',
                            display: 'flex',
                            alignItems: 'center',
                            animation: 'gradientShift 3s ease-in-out infinite',
                            transition: 'all 0.3s ease',
                            '@keyframes gradientShift': {
                                '0%': { backgroundPosition: '0% 50%' },
                                '50%': { backgroundPosition: '100% 50%' },
                                '100%': { backgroundPosition: '0% 50%' }
                            }
                        }}
                    >
                        もマイル
                    </Typography>
                </Toolbar>
            </Container>
        </AppBar>
    );
}

export default Header;
